import React, { Component } from 'react'
import logo from '../../assets/logo.svg'

// components
import Step from './Step/Step'
import Ring from '../Ring/Ring'

// strings
import Strings from "../../assets/strings.json"

class Sidebar extends Component {
  state = {
    tablet: false,
    moreThanTablet: false,
    phone: false,
    moreThanPhone: false
  }
  componentDidMount() {
    this.screenSizes()
    window.addEventListener('resize', this.screenSizes)
  }

  screenSizes = () => {
    this.setState({
      tablet: window.matchMedia('(max-width: 768px)').matches,
      moreThanTablet: window.matchMedia('(min-width: 769px)').matches,
      phone: window.matchMedia('(max-width: 576px)').matches,
      moreThanPhone: window.matchMedia('(min-width: 577px)').matches
    })
  }

  render(){
    return (
      <div className="sidebar md:min-w-22 md:max-w-md md:w-1/3 md:flex flex-col relative pt-12 xl:pl-21 md:pl-16 pl-9 pr-9 md:pb-10 md:bg-grey-lightest md:min-h-screen md:overflow-auto">
        <div className="branding flex sm:justify-between justify-center xxl:mb-24 md:mb-12 mb-8 flex-wrap">
          <a href={document.body.dataset.lang === 'default' ? '/' : '/en'} title="Branntips.no"><img src={logo} className="logo md:w-50 w-40 mb-4" alt="Branntips logo" /></a>
          { this.state.moreThanPhone ? <Ring /> : null }
        </div>
        <div className="list pl-16 md:mb-12 md:block flex justify-between relative">
          { this.state.tablet ? <div className="list-line w-full h-px bg-grey-lighter absolute pin-l"></div> : null }
          { this.props.steps.map((step, i) => <Step moreThanTablet={this.state.moreThanTablet} key={i} index={i+1} name={step.name} active={step.active || false} disabled={!step.complete || this.props.completed} chStep={step.changeStep} /> ) }
          <Step moreThanTablet={this.state.moreThanTablet} index={this.props.steps.length+1} name={this.props.finish.short} active={this.props.completed}  disabled={true} />
        </div>
        { this.state.moreThanTablet ? <div className="bottom mt-auto"><a className="text-sm font-semibold text-black no-underline" href={document.body.dataset.lang === 'default' ? '/personvernerklering' : '/en/privacy-policy'} target="_blank">{ Strings[document.body.dataset.lang].pp }</a></div> : null }
      </div>
    )
  }
}

export default Sidebar
